import React from 'react';
import {omit, flow, useBuffer, useNamedSelector} from 'helpers';
import {create} from 'store/activities';
import css from './card.module.scss';

export function DraftCard({ style, date, time, reset }) {
  const googleCalendarId = useNamedSelector('googleCalendar.defaultCalendar');
  const [control] = useBuffer({
    onChange: flow(
      ({ value }) => ({ name: value, ts: date.unix(), time, googleCalendarId }),
      create,
      reset,
    ),
  });
  return (
    <div className={css.draftCard} style={style}>
      <input
        autoFocus
        className={css.nameEdit}
        placeholder="Enter activity.."
        {...omit(control, 'focused')}
      />
    </div>
  );
}
